export const legalNotices = {
  propertyDisclaimer:
    'La información, el precio y la disponibilidad de esta propiedad pueden variar y deberán confirmarse al momento de la consulta.',
  priceAvailabilityFooter:
    'Los precios, disponibilidad y características publicadas son referenciales y están sujetos a confirmación. Las imágenes pueden ser ilustrativas.',
  serviceDifferentiation:
    'UGA Bienes Raíces presta servicios de gestión e intermediación inmobiliaria. Los servicios jurídicos relacionados podrán ser prestados separadamente por Urribarrí, García & Asociados o por los profesionales que correspondan. El alcance, contratación, honorarios y responsabilidades de cada servicio serán informados previamente.',
  serviceDifferentiationTodo: 'TODO: REVISIÓN Y APROBACIÓN LEGAL',
  guideDisclaimer:
    'El contenido de esta guía es informativo y no sustituye una evaluación jurídica o inmobiliaria particular.',
  demoData:
    'Los datos mostrados en esta sección son demostrativos y deben reemplazarse antes de la publicación oficial.',
  legalPagesTodo: 'TODO: APROBACIÓN LEGAL',
  logoTodo: 'TODO: REEMPLAZAR CON LOGOTIPO DEFINITIVO',
} as const;

export const privacyPolicyProvisional = {
  title: 'Política de privacidad',
  lastUpdated: '2026-01-01',
  sections: [
    {
      heading: 'Responsable del tratamiento',
      content:
        'TODO: CONFIRMAR INFORMACIÓN — Identificar la persona jurídica responsable del tratamiento de datos personales recopilados a través de este sitio web.',
    },
    {
      heading: 'Datos que recopilamos',
      content:
        'A través de formularios de contacto, consultas sobre propiedades, solicitudes de visita y captación de inmuebles, podemos recopilar: nombre, apellido, teléfono, correo electrónico, preferencias de contacto e información sobre el inmueble de interés.',
    },
    {
      heading: 'Finalidad del tratamiento',
      content:
        'Los datos se utilizan para responder consultas, coordinar visitas, evaluar solicitudes de captación, enviar información solicitada y mejorar nuestros servicios.',
    },
    {
      heading: 'Base legal',
      content: 'TODO: APROBACIÓN LEGAL — Definir bases legales aplicables conforme a la normativa venezolana.',
    },
    {
      heading: 'Conservación',
      content:
        'Los datos de prospectos se conservarán durante el tiempo necesario para atender la solicitud y conforme a la política interna de retención. TODO: CONFIRMAR INFORMACIÓN.',
    },
    {
      heading: 'Derechos del titular',
      content:
        'Puedes solicitar acceso, rectificación, eliminación u oposición al tratamiento de tus datos contactándonos a través de los medios indicados en la página de contacto.',
    },
    {
      heading: 'Transferencias',
      content:
        'No vendemos ni cedemos datos personales a terceros con fines comerciales. Algunos proveedores tecnológicos (como Firebase/Google) pueden procesar datos en nombre de la organización.',
    },
  ],
};

export const termsProvisional = {
  title: 'Términos de uso',
  lastUpdated: '2026-01-01',
  sections: [
    {
      heading: 'Aceptación',
      content:
        'Al utilizar este sitio web, aceptas estos términos de uso provisionales. TODO: APROBACIÓN LEGAL.',
    },
    {
      heading: 'Naturaleza del servicio',
      content: legalNotices.serviceDifferentiation,
    },
    {
      heading: 'Información de propiedades',
      content: legalNotices.propertyDisclaimer,
    },
    {
      heading: 'Limitación de responsabilidad',
      content:
        'La información publicada tiene carácter informativo. UGA Bienes Raíces no garantiza resultados específicos en operaciones inmobiliarias. TODO: APROBACIÓN LEGAL.',
    },
    {
      heading: 'Propiedad intelectual',
      content:
        'El contenido, diseño y marca de este sitio están protegidos. No está permitida su reproducción sin autorización.',
    },
  ],
};

export const cookiesPolicyProvisional = {
  title: 'Política de cookies',
  lastUpdated: '2026-01-01',
  sections: [
    {
      heading: '¿Qué son las cookies?',
      content:
        'Las cookies son pequeños archivos que se almacenan en tu dispositivo para mejorar la experiencia de navegación.',
    },
    {
      heading: 'Cookies esenciales',
      content:
        'Utilizamos cookies esenciales para recordar tus preferencias de consentimiento y el funcionamiento básico del sitio.',
    },
    {
      heading: 'Cookies analíticas',
      content:
        'Con tu consentimiento, podemos utilizar Firebase Analytics para comprender el uso del sitio. No se envían datos personales identificables.',
    },
    {
      heading: 'Gestión de preferencias',
      content:
        'Puedes aceptar, rechazar o modificar tus preferencias de cookies en cualquier momento desde esta página o el banner de consentimiento.',
    },
  ],
};
